import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, PieChart, Pie, Cell } from 'recharts';

export default function AdminAnalytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get('/analytics').then(r => setA(r.data)); }, []);
  if (!a) return <div className="text-muted-foreground">Loading…</div>;

  const summary = [
    { label: 'Active Clients', value: a.active_clients, color: '#00C8FF' },
    { label: 'At Risk', value: a.clients_at_risk, color: '#FF8A4C' },
    { label: 'New 30d', value: a.new_clients_30d, color: '#65A30D' },
  ];
  const pieData = [
    { name: 'Active', value: a.active_clients, color: '#00C8FF' },
    { name: 'At Risk', value: a.clients_at_risk, color: '#FF8A4C' },
    { name: 'Other', value: Math.max(0, a.total_clients - a.active_clients - a.clients_at_risk), color: '#475569' },
  ];

  return (
    <div className="space-y-6" data-testid="admin-analytics">
      <div>
        <div className="label-mini text-[#00C8FF]">Insights</div>
        <h1 className="font-display font-black text-4xl mt-1">Analytics</h1>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="regen-card-elevated p-5"><div className="label-mini">Total Revenue</div><div className="font-mono text-3xl mt-2 text-[var(--c-green-ink)]">${a.total_revenue.toLocaleString()}</div></div>
        <div className="regen-card-elevated p-5"><div className="label-mini">Avg YourReGen Score</div><div className="font-mono text-3xl mt-2 text-[#00C8FF]">{a.avg_regen_score}</div></div>
        <div className="regen-card-elevated p-5"><div className="label-mini">Total Clients</div><div className="font-mono text-3xl mt-2">{a.total_clients}</div></div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="regen-card-elevated p-6">
          <div className="label-mini">Client Distribution</div>
          <div className="h-64 mt-3">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={summary}>
                <XAxis dataKey="label" />
                <YAxis />
                <Tooltip contentStyle={{ background: '#101E30', border: '1px solid rgba(255,255,255,0.08)' }} />
                <Bar dataKey="value" radius={[8, 8, 0, 0]}>
                  {summary.map((s, i) => <Cell key={i} fill={s.color} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="regen-card-elevated p-6">
          <div className="label-mini">Status Breakdown</div>
          <div className="h-64 mt-3">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={pieData} dataKey="value" nameKey="name" innerRadius={60} outerRadius={90}>
                  {pieData.map((p, i) => <Cell key={i} fill={p.color} />)}
                </Pie>
                <Tooltip contentStyle={{ background: '#101E30', border: '1px solid rgba(255,255,255,0.08)' }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex justify-center gap-4 mt-3 text-xs">
            {pieData.map(p => <div key={p.name} className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full" style={{ background: p.color }} />{p.name}</div>)}
          </div>
        </div>
      </div>
    </div>
  );
}
